// extracted by mini-css-extract-plugin
export default {"root":"LiveAudioVisualizerV2_root__PO6gn","styleReference":"LiveAudioVisualizerV2_styleReference__poM66","header":"LiveAudioVisualizerV2_header__+lxk3"};